// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b67fbdf4","622":"6054e601","977":"1bb12ded"}[chunkId] + ".chunk.js";
};